import {ESupplierUserPermissionIds} from 'constants/index';

export const ADMIN_DEFAULT_VALUES: Record<ESupplierUserPermissionIds, boolean> =
  {
    [ESupplierUserPermissionIds.COMPANY_READ]: true,
    [ESupplierUserPermissionIds.COMPANY_WRITE]: true,
    [ESupplierUserPermissionIds.COMPANY_ONBOARD]: false,

    [ESupplierUserPermissionIds.TEAM_READ]: true,
    [ESupplierUserPermissionIds.TEAM_WRITE]: true,

    [ESupplierUserPermissionIds.DEPOT_READ]: true,
    [ESupplierUserPermissionIds.DEPOT_WRITE]: true,

    [ESupplierUserPermissionIds.CUSTOMER_READ]: true,
    [ESupplierUserPermissionIds.CUSTOMER_WRITE]: false,
    [ESupplierUserPermissionIds.CUSTOMER_ADD]: false,

    [ESupplierUserPermissionIds.CUSTOMER_CHAT_READ]: true,
    [ESupplierUserPermissionIds.CUSTOMER_CHAT_WRITE]: true,

    [ESupplierUserPermissionIds.PRODUCT_READ]: true,
    [ESupplierUserPermissionIds.PRODUCT_WRITE]: true,
    [ESupplierUserPermissionIds.PRODUCT_PROMOTE]: true,

    [ESupplierUserPermissionIds.DEPOT_PRODUCT_READ]: true,
    [ESupplierUserPermissionIds.DEPOT_PRODUCT_WRITE]: true,

    [ESupplierUserPermissionIds.QUOTE_READ]: true,
    [ESupplierUserPermissionIds.QUOTE_WRITE]: true,
    [ESupplierUserPermissionIds.QUOTE_MANAGE_DOCUMENTS]: true,

    [ESupplierUserPermissionIds.QUOTE_CHAT_READ]: true,
    [ESupplierUserPermissionIds.QUOTE_CHAT_WRITE]: true,

    [ESupplierUserPermissionIds.ORDER_READ]: true,
    [ESupplierUserPermissionIds.ORDER_WRITE]: true,
    [ESupplierUserPermissionIds.ORDER_MANAGE_DOCUMENTS]: true,
    [ESupplierUserPermissionIds.ORDER_MANAGE_PAYMENTS]: true,

    [ESupplierUserPermissionIds.ORDER_CHAT_READ]: true,
    [ESupplierUserPermissionIds.ORDER_CHAT_WRITE]: true,
  };

export const SALESPERSON_DEFAULT_VALUES: Record<
  ESupplierUserPermissionIds,
  boolean
> = {
  [ESupplierUserPermissionIds.COMPANY_READ]: true,
  [ESupplierUserPermissionIds.COMPANY_WRITE]: false,
  [ESupplierUserPermissionIds.COMPANY_ONBOARD]: false,

  [ESupplierUserPermissionIds.TEAM_READ]: true,
  [ESupplierUserPermissionIds.TEAM_WRITE]: false,

  [ESupplierUserPermissionIds.DEPOT_READ]: true,
  [ESupplierUserPermissionIds.DEPOT_WRITE]: false,

  [ESupplierUserPermissionIds.CUSTOMER_READ]: true,
  [ESupplierUserPermissionIds.CUSTOMER_WRITE]: false,
  [ESupplierUserPermissionIds.CUSTOMER_ADD]: false,

  [ESupplierUserPermissionIds.CUSTOMER_CHAT_READ]: true,
  [ESupplierUserPermissionIds.CUSTOMER_CHAT_WRITE]: true,

  [ESupplierUserPermissionIds.PRODUCT_READ]: true,
  [ESupplierUserPermissionIds.PRODUCT_WRITE]: false,
  [ESupplierUserPermissionIds.PRODUCT_PROMOTE]: false,

  [ESupplierUserPermissionIds.DEPOT_PRODUCT_READ]: true,
  [ESupplierUserPermissionIds.DEPOT_PRODUCT_WRITE]: false,

  [ESupplierUserPermissionIds.QUOTE_READ]: true,
  [ESupplierUserPermissionIds.QUOTE_WRITE]: true,
  [ESupplierUserPermissionIds.QUOTE_MANAGE_DOCUMENTS]: true,

  [ESupplierUserPermissionIds.QUOTE_CHAT_READ]: true,
  [ESupplierUserPermissionIds.QUOTE_CHAT_WRITE]: true,

  [ESupplierUserPermissionIds.ORDER_READ]: true,
  [ESupplierUserPermissionIds.ORDER_WRITE]: true,
  [ESupplierUserPermissionIds.ORDER_MANAGE_DOCUMENTS]: true,
  [ESupplierUserPermissionIds.ORDER_MANAGE_PAYMENTS]: true,

  [ESupplierUserPermissionIds.ORDER_CHAT_READ]: true,
  [ESupplierUserPermissionIds.ORDER_CHAT_WRITE]: true,
};

export const ACCOUNTS_DEFAULT_VALUES: Record<
  ESupplierUserPermissionIds,
  boolean
> = {
  [ESupplierUserPermissionIds.COMPANY_READ]: true,
  [ESupplierUserPermissionIds.COMPANY_WRITE]: false,
  [ESupplierUserPermissionIds.COMPANY_ONBOARD]: false,

  [ESupplierUserPermissionIds.TEAM_READ]: true,
  [ESupplierUserPermissionIds.TEAM_WRITE]: true,

  [ESupplierUserPermissionIds.DEPOT_READ]: true,
  [ESupplierUserPermissionIds.DEPOT_WRITE]: false,

  [ESupplierUserPermissionIds.CUSTOMER_READ]: true,
  [ESupplierUserPermissionIds.CUSTOMER_WRITE]: false,
  [ESupplierUserPermissionIds.CUSTOMER_ADD]: false,

  [ESupplierUserPermissionIds.CUSTOMER_CHAT_READ]: true,
  [ESupplierUserPermissionIds.CUSTOMER_CHAT_WRITE]: false,

  [ESupplierUserPermissionIds.PRODUCT_READ]: true,
  [ESupplierUserPermissionIds.PRODUCT_WRITE]: false,
  [ESupplierUserPermissionIds.PRODUCT_PROMOTE]: false,

  [ESupplierUserPermissionIds.DEPOT_PRODUCT_READ]: true,
  [ESupplierUserPermissionIds.DEPOT_PRODUCT_WRITE]: false,

  [ESupplierUserPermissionIds.QUOTE_READ]: true,
  [ESupplierUserPermissionIds.QUOTE_WRITE]: true,
  [ESupplierUserPermissionIds.QUOTE_MANAGE_DOCUMENTS]: true,

  [ESupplierUserPermissionIds.QUOTE_CHAT_READ]: true,
  [ESupplierUserPermissionIds.QUOTE_CHAT_WRITE]: true,

  [ESupplierUserPermissionIds.ORDER_READ]: true,
  [ESupplierUserPermissionIds.ORDER_WRITE]: true,
  [ESupplierUserPermissionIds.ORDER_MANAGE_DOCUMENTS]: true,
  [ESupplierUserPermissionIds.ORDER_MANAGE_PAYMENTS]: true,

  [ESupplierUserPermissionIds.ORDER_CHAT_READ]: true,
  [ESupplierUserPermissionIds.ORDER_CHAT_WRITE]: true,
};

export const ADVISOR_DEFAULT_VALUES: Record<
  ESupplierUserPermissionIds,
  boolean
> = {
  [ESupplierUserPermissionIds.COMPANY_READ]: true,
  [ESupplierUserPermissionIds.COMPANY_WRITE]: false,
  [ESupplierUserPermissionIds.COMPANY_ONBOARD]: false,

  [ESupplierUserPermissionIds.TEAM_READ]: true,
  [ESupplierUserPermissionIds.TEAM_WRITE]: false,

  [ESupplierUserPermissionIds.DEPOT_READ]: true,
  [ESupplierUserPermissionIds.DEPOT_WRITE]: false,

  [ESupplierUserPermissionIds.CUSTOMER_READ]: true,
  [ESupplierUserPermissionIds.CUSTOMER_WRITE]: true,
  [ESupplierUserPermissionIds.CUSTOMER_ADD]: false,

  [ESupplierUserPermissionIds.CUSTOMER_CHAT_READ]: true,
  [ESupplierUserPermissionIds.CUSTOMER_CHAT_WRITE]: true,

  [ESupplierUserPermissionIds.PRODUCT_READ]: true,
  [ESupplierUserPermissionIds.PRODUCT_WRITE]: false,
  [ESupplierUserPermissionIds.PRODUCT_PROMOTE]: false,

  [ESupplierUserPermissionIds.DEPOT_PRODUCT_READ]: true,
  [ESupplierUserPermissionIds.DEPOT_PRODUCT_WRITE]: false,

  [ESupplierUserPermissionIds.QUOTE_READ]: false,
  [ESupplierUserPermissionIds.QUOTE_WRITE]: false,
  [ESupplierUserPermissionIds.QUOTE_MANAGE_DOCUMENTS]: false,

  [ESupplierUserPermissionIds.QUOTE_CHAT_READ]: false,
  [ESupplierUserPermissionIds.QUOTE_CHAT_WRITE]: false,

  [ESupplierUserPermissionIds.ORDER_READ]: false,
  [ESupplierUserPermissionIds.ORDER_WRITE]: false,
  [ESupplierUserPermissionIds.ORDER_MANAGE_DOCUMENTS]: false,
  [ESupplierUserPermissionIds.ORDER_MANAGE_PAYMENTS]: false,

  [ESupplierUserPermissionIds.ORDER_CHAT_READ]: false,
  [ESupplierUserPermissionIds.ORDER_CHAT_WRITE]: false,
};
